import './ModalFooter.0c60093f2b818d48e3af72f434c6a31e.css';
export default {"footer":"_footer_9fawy_1","emptyDiv":"_emptyDiv_9fawy_1","actions":"_actions_9fawy_1","additionalFooterContent":"_additionalFooterContent_9fawy_1"};